import $ from "jquery";
import Cookies from "js-cookie";
import setupNavbarPU from "./js/navbarPU"


window.jQuery = $;
window.$ = $;
require("bootstrap-datepicker");
require("bootstrap-slider");

window.octopus = {
    isUserSignedIn: () => !!Cookies.get('OctopusSignedInUser'),
    getSignedInUserCookie: () => Cookies.get('OctopusSignedInUser'),
};

setupNavbarPU();

function normalizeUtm(utmValue, maxLength = 100){
    if(!utmValue){
        return "";
    }

    return utmValue.substring(0, maxLength).trim().toLowerCase();
}

function sanitizeUrlData(data) {
  if (typeof data !== "string") {
    return "";
  }

  // Remove script tags and event handlers
  const dangerousPatterns = [
    /javascript:[^\s]+/gi,              // Removes 'javascript:' including any whitespace following it.
    /vbscript:[^\s]+/gi,                // Removes 'vbscript:' including any whitespace following it.
    /data:[^\s]+/gi,                    // Removes 'data:' including any whitespace following it.
    /file:[^\s]+/gi,                    // Removes 'file:' including any whitespace following it.
    /base64,[^\s]+/gi,                  // Removes 'base64,' including any whitespace following it.
    /(&#x?\d+;)+/gi,                    // Removes HTML entity encodings
    /<script.*?>.*?<\/script>/gis,      // Removes complete script tags and their contents.
    /<[^>]+>/gi,                        // Removes any other complete HTML tags.
    /%0a|%0d|%09/gi,                    // Removes encoded line breaks, carriage returns, and tabs.
    /&#[xX]?[0-9a-fA-F]+;/gi,           // Removes numeric HTML entities.
    /on\w+\s*=\s*["']?[^"'>]*["']?/gi,  // Removes HTML event handlers with quotes
    /on\w+\s*=\s*[^"'\s>]+/gi,          // Removes HTML event handlers without quotes
    /<\/script>/gi,                     // Removes script tag terminators.
    /\(['"]?[^)'"]*['"]?\)/gi,          // Removes parentheses with optional quotes and content
    /['"()]/g,                          // Final cleanup for stray single/double quotes and parentheses
  ];

  dangerousPatterns.forEach((pattern) => {
    data = data.replace(pattern, "");
  });

  // URL encode the sanitized data to safely use or display it
  return encodeURIComponent(data);
}

// If this function is updated also update it in Octopus-com
function intercomUtmTracking() {
    const signedInCookie = Cookies.get('OctopusSignedInUser');
    const searchParams = new URLSearchParams(window.location.search);
    let hasUtmParams = false;
    for(const key of searchParams.keys()) {
        if(key.startsWith("utm_")){
            hasUtmParams = true;
            break;
        }
    }

    // if user is not signed in and has UTM params
    // If further throttling is required for event sending we could deduplicate events by comparing the last sent to the event to be sent
    if (!signedInCookie && hasUtmParams && Intercom) {
        Intercom('trackEvent', "OctopusAnonymousUtmTracking", {
            host: sanitizeUrlData(window.location.hostname),
            path: sanitizeUrlData(window.location.pathname),
            source: normalizeUtm(searchParams.get("utm_source")),
            medium: normalizeUtm(searchParams.get("utm_medium")),
            campaign: normalizeUtm(searchParams.get("utm_campaign")),
            term: normalizeUtm(searchParams.get("utm_term")),
            content: normalizeUtm(searchParams.get("utm_content")),
            googleClickId: normalizeUtm(searchParams.get("gclid")),
        });
    }
}
window.addEventListener('load', intercomUtmTracking);

window.initializeFeatherlight = function initializeFeatherlight() {
    let ts;
    $.featherlight.defaults.closeOnClick = 'anywhere';
    $.featherlight.defaults.afterOpen = function () {
        ts = +new Date();
        $(window).on('scroll', closeFeatherlightOnScroll);
    };

    function closeFeatherlightOnScroll(event) {
        const nowTs = +new Date();

        if (ts + 500 > nowTs) {
            return;
        }
        $.featherlight.close(event);
        $(window).off('scroll', closeFeatherlightOnScroll);
    }
};

window.copyToClipboard = function copyStringToClipboard(str) {
    const hiddenElement = document.createElement('textarea');
    hiddenElement.value = str;
    hiddenElement.setAttribute('readonly', '');
    hiddenElement.style = {display: 'none'};
    document.body.appendChild(hiddenElement);
    hiddenElement.select();
    document.execCommand('copy');
    document.body.removeChild(hiddenElement);
}

window.miniStateMachine = function (parentElement, steps, defaultWait, repeat) {
    let step = 0;

    const next = function () {
        let result = steps[step]();
        if (!Number.isInteger(result)) {
            result = defaultWait || 300;
        }
        step++;
        if (step >= steps.length && repeat) {
            console.log("msm repeating");
            step = 0;
        }

        if (step < steps.length) {
            setTimeout(next, result);
        }
    };

    let loaded = false;
    const onIntersection = (entries) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                if (!loaded) {
                    loaded = true;
                    next();
                }
            }
        }
    };

    const observer = new IntersectionObserver(onIntersection);
    observer.observe(document.querySelector(parentElement));
};

window.initializeTableOfContents = function (documentRef, contentElementId, selectors) {
    documentRef = documentRef || window.document;
    const toc = documentRef.getElementById('toc');
    const headings = [].slice.call(documentRef.getElementById(contentElementId).querySelectorAll(selectors));

    const html = [];
    html.push("<div style='margin: 5px 0 0 12px'><strong>On this page</strong></div>");
   
    // toc search
    html.push("<div class='search-only toc-search'>");
    html.push("<div class='input-group'>");
    html.push("<input type='text' class='form-control toc-search-input' placeholder='Search...'>");    
    html.push("<button type='button' class='btn btn-sm toc-search-clear bg-white' style='margin-left: -40px; z-index: 100;'>");
    html.push("<i class='fa fa-fw fa-times' style='margin-right:0;' title='Clear'></i>");
    html.push("</button></div>");
    html.push("<button class='btn btn-light btn-sm toc-search-next' aria-label='Next'><i class='fa fa-fw fa-arrow-down' style='margin-right:0;' title='Next'></i></button>");
    html.push("<button class='btn btn-light btn-sm toc-search-prev' aria-label='Previous'><i class='fa fa-fw fa-arrow-up' style='margin-right:0; title='Previous'></i></button>");
    html.push("</div><hr/>");

    let groupId = "";
    headings.forEach(function (heading, index) {
        const tag = heading.tagName.toLowerCase();
        const id = heading.id;
        const title = heading.textContent;
        if (tag === "h2") {
            groupId = id;
        }

        const element = "<a class='toc-item toc-" + tag + "' href='#" + id + "' data-target='" + id + "' data-group='" + groupId + "'>" + heading.textContent + "</a>";
        if (title === "Next") {
            return;
        }
        html.push(element);
    });

    if (html.length < 4) {
        document.getElementById("toc-column").className = "d-none";
    } else {
        toc.innerHTML = html.join('');
    }

    $(function () {
        $(".toc-item").click(function (e) {
            e.preventDefault();
            const id = $(this).attr("href");
            if (id) {
                $("html, body").delay(100).animate({scrollTop: $(id).offset().top - 140}, 300);
            }
            return false;
        });

        const headings = [].slice.call(document.querySelectorAll(selectors));
        const refreshScrollPosition = function () {
            const scrollY = window.scrollY;
            let closest = null;
            $(selectors, $(documentRef.getElementById(contentElementId))).each(function () {
                const me = $(this);
                const pos = me.offset();
                if (scrollY + 180 > pos.top) {
                    closest = this;
                }
            });

            let current = null;
            $("#toc a.active").removeClass("active");
            if (closest) {
                current = $("#toc a[data-target='" + closest.id + "']");
            } else {
                current = $("#toc a").first();
            }

            current.addClass("active");

            const groupToExpand = $("#toc .toc-item.active").data("group");
            $("#toc .toc-item.toc-h3,.toc-item.toc-h4").each(function () {
                if ($(this).data("group") === groupToExpand) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        };

        window.addEventListener("scroll", refreshScrollPosition);
        window.addEventListener("resize", refreshScrollPosition);
        refreshScrollPosition();

        const $toc = $("#toc");
        const tocHeight = $toc.height();
        if (tocHeight + 100 > $(window).height()) {
            $toc.css("position", "static");
        } else {
            $toc.css("position", "sticky");
        }

        // toc-search 
        let $input = $(".toc-search-input"),
              $clearBtn = $(".toc-search-clear"),
              $prevBtn = $(".toc-search-prev"),
              $nextBtn = $(".toc-search-next"),
              currentClass = "current"

        let $content = $(documentRef.getElementById(contentElementId)),
            $results,
            offsetTop = 66,
            currentIndex = 0;
        
        // Jumps to the element matching the currentIndex
        function jumpTo() {
            if ($results?.length) {
                let position,
                    $current = $results.eq(currentIndex);
                $results.removeClass(currentClass);
                if ($current.length) {
                    $current.addClass(currentClass);
                    position = $current.offset().top - offsetTop;
                    window.scrollTo(0, position);
                }
            }
        }
        
        // Searches for the entered keyword in the specified context on input
        $input.on("input", function () {
            let searchVal = this.value;
            $content.unmark({
                done: function () {
                    $content.mark(searchVal, {
                        separateWordSearch: true,
                        done: function () {
                            $results = $content.find("mark");
                            currentIndex = 0;
                            jumpTo();
                        }
                    });
                }
            });
        });

        // Clears the search
        $clearBtn.on("click", function () {
            $content.unmark();
            $input.val("").focus();
        });

        // Next and previous search jump to
        $nextBtn.add($prevBtn).on("click", function () {
            if ($results?.length) {
                currentIndex += $(this).is($prevBtn) ? -1 : 1;
                if (currentIndex < 0) {
                    currentIndex = $results.length - 1;
                }
                if (currentIndex > $results.length - 1) {
                    currentIndex = 0;
                }
                jumpTo();
            }
        });
    });
};

window.enablePasswordStrength = function () {
    $('.password-strength-meter').each(function () {
        const output = $(this);
        const password = $($(this).data("target"));

        const checkPassword = function () {
            output.removeClass("bg-danger bg-warning bg-success");
            const val = password.val();
            if (val === "") {
                output.css("width", "0%");
                return;
            }

            const result = zxcvbn(val);

            // Update the password strength meter
            if (result.score < 1) {
                output.addClass("bg-danger");
            } else if (result.score < 3) {
                output.addClass("bg-warning");
            } else {
                output.addClass("bg-success");
            }

            const warnings = [];
            if (result.feedback.warning) {
                warnings.push(result.feedback.warning);
            }

            if (result.feedback && result.feedback.suggestions) {
                for (let i = 0; i < result.feedback.suggestions.length; i++) {
                    warnings.push(result.feedback.suggestions[i]);
                }
            }

            output.css("width", 20 + (result.score * 20) + "%");
            let text = warnings.join("<br />");
            if (text === "") text = "Great password!";
            output.attr("title", text).attr("data-original-title", text).tooltip({
                html: true
            }).tooltip('update');
        };

        password.on('input', function () {
            checkPassword();
        });

        checkPassword();
    });
};

window.enableDynamicValidation = function ($form, url) {
    let urlFunc = typeof url === 'function' ? url : function() { return url; };
    function dynamicValidation($element) {
        let validationRequest = null;
        let validationTimer = null;
        let statusElementTimer = null;

        const validationControls = $('<span style="position: absolute; top: 5px; right: 10px; padding: 4px; z-index: 1000; display: block" class="validation-status-container" data-toggle="tooltip" data-placement="bottom" title="">\n' +
            '                      <i class="validation-status-validating fad fa-circle-notch fa-spin text-primary" style="display:none" role="presentation"></i>\n' +
            '                      <i class="validation-status-valid fas fa-check-circle text-success" style="display:none" role="presentation"></i>\n' +
            '                      <i class="validation-status-invalid fas fa-times-circle text-danger" style="display:none" role="presentation"></i>\n' +
            '                  </span>');

        const $input = $("input", $element);
        
        // We want to avoid sending any potentially sensitive values to the server via query string parameters
        if($input.attr("type") === "password"){
            return;
        }
        
        const propertyName = $input.attr("name");
        let $validationError = $(`[data-valmsg-for='${propertyName}']`);

        $element.append(validationControls);

        const resetValidationStatus = function () {
            $(".validation-status-valid", $element).hide();
            $(".validation-status-invalid", $element).hide();
            $(".validation-status-container", $element).attr("title", "").attr("data-original-title", "").tooltip('hide');
            if (validationRequest) validationRequest.abort();
            if (validationTimer) clearTimeout(validationTimer);
            if (statusElementTimer) clearTimeout(statusElementTimer);
            if ($input.val() === "") {
                $(".validation-status-validating", $element).hide();
            } else {
                $(".validation-status-validating", $element).show();
            }
        };

        const resetValidationError = function () {
            $validationError.html(null);
            $validationError.removeClass();
            $validationError.addClass("field-validation-valid");
        };

        const validate = function () {
            resetValidationStatus();

            const inputValue = $input.val();
            let $form = $input.closest("form");
            let $submit = $form.find("[type=submit]");

            if (inputValue !== "") {
                $submit.prop("disabled", true);
                const start = performance.now();
                validationRequest = $.get(urlFunc() + '?propertyName=' + propertyName + "&" + propertyName + "=" + encodeURIComponent(inputValue), function (data) {
                    const end = performance.now();
                    $input.removeClass('invalid valid');
                    $input.addClass(data.valid ? 'valid' : 'invalid');

                    //calculate timeout for the UI
                    const requestDuration = end - start;
                    const uiDelay = Math.max(0, 500 - requestDuration);

                    statusElementTimer = setTimeout(function () {
                        $(".validation-status-validating", $element).hide();
                        if (data.valid) {
                            $(".validation-status-valid", $element).show();
                        } else {
                            $(".validation-status-container", $element).attr("title", data.error).attr("data-original-title", data.error).tooltip();
                            $(".validation-status-invalid", $element).show();

                            $validationError.html(data.error);
                            $validationError.removeClass();
                            $validationError.addClass("field-validation-error");
                        }
                    }, uiDelay);
                }).always(function () {
                    if ($form.find('input.invalid:visible').length === 0)
                        $submit.prop("disabled", false);
                });
            } else {
                // resets validation when the input is cleared
                resetValidationStatus();
                $input.removeClass('invalid valid');
                if ($form.find('input.invalid:visible').length === 0)
                    $submit.prop("disabled", false);
            }
        };

        $input.on('input', function () {
            resetValidationStatus();
            resetValidationError();
            $(".validation-status-validating", $element).hide();

            validationTimer = setTimeout(function () {
                validate();
            }, 500);
        });

        validate();
    }

    $(".dynamic-validation", $form).each(function () {
        dynamicValidation($(this));
    });
};

// Report an event to Google Analytics after 30 seconds of the browser tab being active. This helps us to have a
// bounce rate metric that's more useful than the default bounce rate.
(function () {
    let elapsed = 0;
    const pollFrequency = 500;
    let timerId;

    timerId = setInterval(function () {
        if (document.hidden || !document.hasFocus()) {
            return;
        }

        elapsed += pollFrequency;

        if (elapsed >= 30000) {
            if (typeof window.gtag !== "undefined") {
                gtag('event', 'Page active 30s', {'event_category': 'Page'});
            }
            clearInterval(timerId);
        }
    }, pollFrequency);
})();

$(function () {

    function initializeSvgImageFallback() {
        // We use lots of .svg files. If the browser doesn't
        // support SVG, we have to fall back to .png's in the
        // same folder. Assumption is that if we use a .svg there will
        // be a corresponding fallback .png.

        if (!document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1")) {
            $("img[src$='.svg']").each(function (i) {
                $(this).attr("src", $(this).attr("src").replace(".svg", ".png"));
            });

            $(".without-svg").show();
            $(".with-svg").hide();
        }
    }

    function initializeAjax() {
        // Some pages like pricing make use of AJAX - let's make sure the responses aren't cached
        $.ajaxSetup({cache: false});
    }

    function initializeNavbarShadowOnScroll() {
        let hasShadow = false;
        window.addEventListener("scroll", function (event) {
            const scroll = this.scrollY;
            if (scroll <= 10 && hasShadow) {
                $(".navbar.fixed-top").removeClass("navbar-sticky-scrolling");
                hasShadow = false;
            } else if (scroll > 10 && !hasShadow) {
                $(".navbar.fixed-top").addClass("navbar-sticky-scrolling");
                hasShadow = true;
            }
        });
    }

    $(function () {
        const lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

        if ("IntersectionObserver" in window) {
            const lazyImageObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var lazyImage = entry.target;
                        lazyImage.src = lazyImage.dataset.src;
                        if (typeof (lazyImage.dataset.srcset) !== 'undefined') {
                            lazyImage.srcset = lazyImage.dataset.srcset;
                        }
                        lazyImage.classList.add("loaded");
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            });

            lazyImages.forEach(function (lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        } else {
            // Load automatically
            setTimeout(function () {
                lazyImages.forEach(function (lazyImage) {
                    lazyImage.src = lazyImage.dataset.src;
                    if (typeof (lazyImage.dataset.srcset) !== 'undefined') {
                        lazyImage.srcset = lazyImage.dataset.srcset;
                    }
                    lazyImage.classList.add("loaded");
                });
            }, 1000);
        }
    });


    function initializePopovers() {
        $('[data-toggle="popover"]')
            .popover({html: true, trigger: 'focus'})
            .click(function (e) {
                e.preventDefault();
            });
    }

    function updateIntercom(data) {
        window.intercomSettings = window.intercomSettings || {};
        window.intercomSettings.name = data.fullName;
        window.intercomSettings.email = data.email;
        window.intercomSettings.user_id = data.id;
        window.intercomSettings.user_hash = data.intercomUserHash;
        if (data.profileImage) {
            window.intercomSettings.avatar = {
                type: 'avatar',
                image_url: data.profileImage
            };
        }
        if(typeof Intercom !== 'undefined')
            Intercom('update');
    }

    function initializeProfileMenu() {
        const $signIn = $("#navbar-sign-in");
        const $signUp = $("#navbar-sign-up");
        const $navbarProfile = $('#navbar-profile');
        const signedInCookie = Cookies.get('OctopusSignedInUser'); 
        // if user is signed in
        if (!!signedInCookie && $navbarProfile.length > 0) {
            let data = JSON.parse(signedInCookie);

            const name = data.fullName ?? data.email;

            //if the image is available, show the image and hide the circle
            if (!!data.profileImageUrl) {
                $navbarProfile.find('#navbar-profile-image img').attr('title', name).attr('src', data.profileImageUrl).show();
                $navbarProfile.find('#navbar-profile-image :not(img)').remove();
            }

            $navbarProfile.find('#navbar-profile-sign-out').toggle(data.method === 'Auth');

            $navbarProfile.find('#navbar-profile-name').text(name);
            $navbarProfile.show();

            window._dcq = window._dcq || [];
            _dcq.push(["identify", {email: data.email, prospect: true}]);

            if (window.FS) {
                FS.identify(data.userHash, {
                    displayName: data.fullName,
                    email: data.email
                });
            }

            $signIn.hide();
            $signUp.hide();

            updateIntercom(data);
        } else {
            $signIn.show();
            $signUp.show();
        }
    }

    function initializeLoadOnScroll() {
        let hasPageLoaded = false;
        const onIntersection = (entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('loaded');
                } else {
                    if (!hasPageLoaded) {
                        entry.target.classList.add('awaiting-scroll');
                    }
                }
            }
        };

        setTimeout(function () {
            hasPageLoaded = true;
        }, 1000);

        const observer = new IntersectionObserver(onIntersection);
        document.querySelectorAll('.load-on-scroll').forEach(e => observer.observe(e));
    }
    

    initializeLoadOnScroll();

    initializeProfileMenu();
    initializeNavbarShadowOnScroll();
    initializeSvgImageFallback();
    initializeAjax();
    initializePopovers();
});

// Global tooltips
$(function () {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="tooltip-click"]').tooltip(
        {
            trigger: 'click',
            animation: true
        }
    );
    $(document).on('click', hideTooltips);
    function hideTooltips(e){
        const toggleAttr = $(e.target).attr('data-toggle');
        if (["tooltip-click", "tooltip"].includes(toggleAttr)){
            return;
        }
        $('[data-toggle="tooltip-click"]').tooltip('hide');
    }
});

// Copy to clipboard tooltip
$(function () {
    $('.copy-to-clipboard-tooltip').tooltip(
        {
            trigger: 'focus',
            placement: 'top',
            animation: true,
            delay: {hide: 1500}
        }
    );
});


(function ($) {
    'use strict';

    var timer;

    function trackLeave(ev) {
        if (ev.clientY > 0) {
            return;
        }

        if (timer) {
            clearTimeout(timer);
        }

        if ($.exitIntent.settings.sensitivity <= 0) {
            $.event.trigger('exitintent');
            return;
        }

        timer = setTimeout(
            function () {
                timer = null;
                $.event.trigger('exitintent');
            }, $.exitIntent.settings.sensitivity);
    }

    function trackEnter() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }

    $.exitIntent = function (enable, options) {
        $.exitIntent.settings = $.extend($.exitIntent.settings, options);

        if (enable === 'enable') {
            $(window).mouseleave(trackLeave);
            $(window).mouseenter(trackEnter);
        } else if (enable === 'disable') {
            trackEnter(); // Turn off any outstanding timer
            $(window).unbind('mouseleave', trackLeave);
            $(window).unbind('mouseenter', trackEnter);
        } else {
            throw "Invalid parameter to jQuery.exitIntent -- should be 'enable'/'disable'";
        }
    }

    $.exitIntent.settings = {
        'sensitivity': 300
    };

})(jQuery);

// NOTE: If this is changed, it also needs to be changed in OctopusMarketing/Octopus.Web.Public
// handle the OctopusEvents cookie
$(function () {
    const cookieName = 'OctopusEvents'
    const eventsCookie = Cookies.get(cookieName);
    if (!!eventsCookie) {
        let events = JSON.parse(eventsCookie);

        for (let i = 0; i < events.length; i++) {
            const ev = events[i];
            switch (ev.Type) {
                case 'TrackingEvent':
                    WriteTrackingEvent(ev);
                    break;
                case 'FormProgressEvent':
                    WriteFormProgressEvent(ev);
                    break;
                case 'LeadTrackingEvent':
                    WriteLeadTrackingEvent(ev);
                    break;
                default:
                    console.debug(`Unknown event type encountered: ${ev.Type}`);
                    break;
            }
        }

        //Remove the cookie once we are done processing it
        Cookies.remove(cookieName);
    }
    
    function WriteLeadTrackingEvent(ev) {

        // Marketo
        const marketoFormId = ev.Data.MarketoFormId;
        const marketoAccountId = ev.Data.MarketoAccountId;
        if (marketoFormId && marketoAccountId) {
            LoadScriptAsync("//get.octopus.com/js/forms2/js/forms2.min.js", function () {
                // add hidden form
                let hiddenForm = document.createElement('form');
                hiddenForm.id = "mktoForm_" + marketoFormId;
                hiddenForm.style.display = "none";
                document.getElementsByTagName('body')[0].appendChild(hiddenForm);

                MktoForms2.loadForm('//get.octopus.com', marketoAccountId, marketoFormId, function (form) {
                    form.addHiddenFields(ev.Data.MarketoFields);
                    form.onSuccess(function () {
                        // Return false to prevent the submission handler continuing with its own processing
                        return false;
                    });
                    form.submit();
                });
            });
        }
    }

    function WriteTrackingEvent(ev) {
        const action = ev.Data.Action;
        const category = ev.Data.Category;

        //Write LinkedIn image but only for new accounts
        if (action === 'NewAccount') {
            $('body').append('<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=2493924&fmt=gif&conversionId=4675260"/>');
        }

        //Microsoft Ads
        if (window.uetq) {
            window.uetq.push('event', action, {event_category: category});
        }

        // Drip
        if (window._dcq) {
            _dcq.push(['track', action, {category: category}]);
        }

        //FullStory
        if (window.FS) {
            window.FS.event(action, {category: category});
        }

        //Google Tag Manager
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'eventTracking',
                category: category,
                action: action
            });
        }
    }

    function WriteFormProgressEvent(ev){
        const step = ev.Data.Step;
        const stepNumber = ev.Data.StepNumber;
        const platform = ev.Data.Platform;

        //Google Tag Manager
        if (window.dataLayer) {
            window.dataLayer.push({
                'event': 'form_progress',
                'step': step,
                'stepNumber': stepNumber,
                'platform': platform
            });
        }

    }
    
    function LoadScriptAsync(scriptUrl, callback) {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = scriptUrl;
        s.onreadystatechange = function () {
            if (this.readyState == 'complete' || this.readyState == 'loaded') {
                callback();
            }
        };
        s.onload = callback;
        document.getElementsByTagName('head')[0].appendChild(s);
    }
});

$(function () {
    // handles the PathTracking cookie for URL tracking
    function setPageCookie() {
        const sanitizedHostname = sanitizeUrlData(window.location.hostname);
        const sanitizedPathname = sanitizeUrlData(window.location.pathname);
        const pathTrackingValue = sanitizedHostname + sanitizedPathname;

        Cookies.set("OctopusPathTracking", pathTrackingValue, {
          secure: true,
          expires: 7,
          sameSite: "strict",
        });
    }
    window.addEventListener('load', setPageCookie);
});